export default {
  SignUp: 'SignUp',
  SignUpWithToken: 'SignUpWithToken',
  SignUpPreLaunch: 'SignUpPreLaunch',
  Login: 'Login',
  ForgotPassword: 'ForgotPassword',
  ResetYourPassword: 'ResetYourPassword',
  CheckYourEmail: 'CheckYourEmail',
  About: 'About',
  Business: 'Business',
  Phone: 'Phone',
  PhoneConfirm: 'PhoneConfirm',
  Booking: 'Booking',
  FinalStep: 'FinalStep',
  Completed: 'Completed',
  FreeAccount: 'FreeAccount',
  LaunchDate: 'LaunchDate',
  OnboardingComplete: 'OnboardingComplete',
  CompletedQuoteGenerator: 'CompletedQuoteGenerator',
  CertifyFulfillmentSettings: 'CertifyFulfillmentSettings',
  Initialize: 'Initialize',
  Logout: 'Logout',
  Refresh: 'Refresh'
}
